import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';

import { useAppSelector } from '@core/store/hooks';
import { homePathForRole } from '@core/utils/roleHome';

/**
 * `/verify-email` is only meaningful for a signed-in user whose email is still unverified.
 * Both other cases redirect, because the page has nothing to show them.
 */
export function VerifyEmailRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const token = useAppSelector((s) => s.auth.token);
  const user = useAppSelector((s) => s.auth.user);

  if (!isAuthenticated || !token) return <Navigate to='/login' replace />;
  if (user?.emailVerified !== false) return <Navigate to={homePathForRole(user?.role)} replace />;

  return <>{children}</>;
}
